// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientLookupResponseModel {
    static getAttributeTypeMap() {
        return PatientLookupResponseModel.attributeTypeMap;
    }
}
PatientLookupResponseModel.discriminator = undefined;
PatientLookupResponseModel.additionalProperties = false;
PatientLookupResponseModel.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "EnrollmentHybridPatientSearchDemographicsModel"
    },
    {
        "name": "enrollments",
        "baseName": "enrollments",
        "type": "Array<HybridEnrollmentHistoryModel>"
    },
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "EnrollmentMedBenClientIdentifiersModel"
    },
];
//# sourceMappingURL=patientLookupResponseModel.js.map